import React, {Component} from 'react';
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
/*import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCogs} from '@fortawesome/free-solid-svg-icons'*/
import API from "../../services/API";
// import {toast} from "react-toastify";
import Toast from "../Common/Toast";
import Loading from "../Common/Loading";
class Home extends Component {
    state = {
        requests : [],
        isLoaded : false,
    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast  />
                <Actionbar noBack={1}/>
                <section className="container mt-4 ">
                    <div className="row px-2">
                        <div className="col-12 text-center fw-bold mb-3">
                          لیست درخواست ها
                        </div>
                        {
                            this.state.requests.map (request => {
                                return (
                                    <div className="col-12 rtl mb-2 request-row pb-2 "
                                        onClick={() => this.props.history.push(`/request/${request.id}`)}
                                    >
                                        <div className="row  mx-2 py-2">
                                            <div className="col-6 badge badge-info badge-pill bg-primary float-right ">{request.company.title}</div>
                                            <div className="col-6 text-left super-small" style={{color:request.status.color}}>{request.status.title}</div>
                                            <div className="col-12 mt-2 small">
                                                از:
                                                &nbsp;
                                                {request.loading_addresses[0].title}
                                                &nbsp;
                                                {request.loading_addresses[0].address.substring(0, 25)} ...
                                            </div>
                                            <div className="col-12 mt-2 small">
                                                به:
                                                &nbsp;
                                                {request.unloading_addresses[0].title}
                                                &nbsp;
                                                {request.unloading_addresses[0].address.substring(0, 25)} ...
                                            </div>
                                        </div>
                                    </div>
                                )} )
                        }
                    </div>
                </section>

                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {
            proccess_for : 'Driver',
        }
        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                this.setState({requests})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)
            })
            .catch((error) => {
             //   toast.error(error.response.data.user_message);
            });
    }
}

export default Home;